<template>
  <div class="comp-1">
    <dv-digital-flop
      :config="digitalConfig1"
      style="width: 100%; height: 4rem"
    />
    <dv-digital-flop
      :config="digitalConfig12"
      style="width: 100%; height: 4rem"
    />
  </div>
</template>

<script>
import Bus from "@/utils/event-bus.js";

let configData = [
  [2560, 30],
  [2048, 30],
  [1920, 25],
  [1856, 25],
  [1856, 20],
  [1792, 20],
  [1680, 20],
  [1600, 17],
  [1440, 17],
  [1400, 17],
  [1366, 17],
  [1280, 17],
];

export default {
  data() {
    return {
      compData: {
        allTaskCountThisYear: 0,
        attendanceRate: 0,
      },
      digitalSize: 20,
    };
  },
  mounted() {
    this.loadData();
    window.addEventListener("resize", this.onResize);
    this.onResize();

    Bus.$on("reload-data", this.loadData);
    Bus.$on("province-change", this.loadData);
  },
  methods: {
    loadData() {
      this.$get("/screen/datav/general-situation", {
        province: this.$store.state.common.provinceName,
      }).then((r) => {
        let data = r.data.data;
        this.compData.allTaskCountThisYear = data.allTaskCountThisYear;
        this.compData.attendanceRate = Math.floor(data.attendanceRate * 100);
      });
    },
    onResize() {
      let w = window.innerWidth;
      for (let index = 0; index < configData.length; index++) {
        let current = configData[index];
        if (w >= current[0]) {
          this.digitalSize = current[1];
          break;
        }
      }
    },
  },
  computed: {
    digitalConfig1() {
      return {
        number: [this.compData.allTaskCountThisYear],
        textAlign: "center",
        content: "年服务总量 {nt}",
        animationFrame: 100,
        style: {
          fontSize: this.digitalSize,
          fill: "#1f427c",
        },
      };
    },
    digitalConfig12() {
      return {
        number: [this.compData.attendanceRate],
        textAlign: "center",
        content: "服务出勤率 {nt}%",
        animationFrame: 100,
        style: {
          fontSize: this.digitalSize,
          fill: "#1f427c",
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.comp-1 {}
</style>